import { listSearchSchema } from '@/shared/patterns/list-search';
import { productFilters } from './bank-account-product.filters';
import { z } from 'zod';
export const PRODUCT_TABS = ['informacoes', 'envolvidos', 'documentos'] as const;
export const productListSearch = listSearchSchema({
  ...productFilters.shape,
  sheet: z.string().optional(),
});
export const productDetailSearch = z.object({
  tab: z.enum(PRODUCT_TABS).optional(),
  sheet: z.string().optional(),
});
